import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import UnitCosting from './unit-costing';
import Loadgcpcost from './load-gcp-cost';
import TotalCosting from './total-costing';
import GCPUnitCosting from './gcp-costing';
import OrgWiseCosting from './org-wise-costing';
import OwnershipBasedCosting from './ownership-based-costing';
const Costing = () => {
    return (
        <>
            <Routes>
                <Route index element={<Navigate to={'/home'} />} />
                <Route path="gcp-costing/*" element={<GCPUnitCosting />} />
                <Route path="unit-costing/*" element={<UnitCosting />} />
                <Route path="org-wise-costing/*" element={<OrgWiseCosting />} />
                <Route
                    path="ownership-based-costing/*"
                    element={<OwnershipBasedCosting />}
                />
                <Route path="total-costing/*" element={<TotalCosting />} />
                <Route path="load-vs-gcp-cost/*" element={<Loadgcpcost/>} />
            </Routes>
        </>
    );
};

export default Costing;
